<template>
  <section class="persons-section form-section grid-block">
    <header>
      <span>Контактные лица</span>

      <VLink
        id="create_person_btn"
        theme="link"
        material="add"
        @click="createPerson"
      >
        Добавить контактное лицо
      </VLink>
    </header>

    <div class="content">
      <template v-if="persons.length === 0">
        <div class="content-no-persons">
          Контактных лиц нет
        </div>
      </template>

      <template v-else>
        <article
        v-for="person in persons"
        :key="person.id"
        @dblclick="editPerson(person)"
      >
        <header>
          <div class="title">
            {{ person.name }}
          </div>

          <VContextMenuButton
            :id="'context_menu_person_' + person.id"
            theme="default"
          >
            <VContextMenu
              :items="PersonsService.contextMenu"
              :row="person"
              :on-action="() => $emit('persons:updated')"
            />
          </VContextMenuButton>
        </header>
        <table>
          <thead></thead>
          <tbody>
            <!-- Первая строка с почтой -->
            <tr>
              <td>E-mail</td>
              <td
                @mouseenter="$core.tooltip.show($event.currentTarget, 'Скопировать в буфер обмена')"
                @mouseleave="$core.tooltip.hide()"
                @click="handleCopyToClipboard(person.email)"
              >
                {{ person.email }}
                <VIcon material="content_copy" />
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>

            <!-- Созданные контакты (Номер телефона или скайп) -->
            <tr
              v-for="contact in person.contacts"
              :key="contact.id"
              :class="{ 'priority-contact': contact.isPreferred }"
            >
              <td>{{contact.getTypeStringRepresentation()}}</td>
              <td
                @mouseenter="$core.tooltip.show($event.currentTarget, 'Скопировать в буфер обмена')"
                @mouseleave="$core.tooltip.hide()"
                @click="handleCopyToClipboard(formatPhone(contact))"
              >
                {{ formatPhone(contact) }}
                <VIcon material="content_copy" />
              </td>
              <td>{{ contact.comment }}</td>
              <td>
                <VBadge
                  v-if="contact.isPreferred"
                  @mouseenter="$core.tooltip.show($event.currentTarget, 'Приоритетный контакт')"
                  @mouseleave="$core.tooltip.hide()"
                >
                  ПК
                </VBadge>
              </td>
            </tr>

            <!-- Последняя строка - комментарий -->
            <tr v-if="person.comment && person.comment.length > 0">
              <td>Комментарий</td>
              <td
                @mouseenter="$core.tooltip.show($event.currentTarget, 'Скопировать в буфер обмена')"
                @mouseleave="$core.tooltip.hide()"
                @click="handleCopyToClipboard(person.comment)"
              >
                {{ person.comment }}
                <VIcon material="content_copy" />
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </article>
      </template>
    </div>
  </section>
</template>

<style lang="scss" src="./PersonsSection.scss" />

<script lang="ts">

import Contact        from "@/domains/Contacts/Contact";
import Partner        from "@/domains/Partners/Partner";
import Person         from "@/domains/Persons/Person";
import PersonsService from "@/domains/Persons/PersonsService";

import VContextMenu   from "@/lib/components/VContextMenu/VContextMenu.vue";

export default defineComponent({
  name: "PersonsSection",

  components: {
    VContextMenu,
  },

  props: {
    localPartner: {
      type: Partner,
      default: null,
    },
  },

  setup() {
    return {
      PersonsService,
    };
  },

  computed: {
    persons(): Person[] {
      return this.localPartner.persons ?? [];
    },
  },

  methods: {
    async createPerson(): Promise<void> {
      if (await PersonsService.showPersonCard(null, this.localPartner.id) === true) {
        this.$emit('persons:updated');
      }
      else {
        // ничего не создали
      }
    },

    async editPerson(person: Person): Promise<void> {
      if (await PersonsService.showPersonCard(person.id) === true) {
        this.$emit('persons:updated');
      }
      else {
        // ничего не изменили
      }
    },

    handleCopyToClipboard(entity: any) {
      this.$core.utils.copyToClipboard(entity);
      this.$core.showNotification.success(`${entity} скопирован в буфер обмена`);
    },

    formatPhone(contact: Contact) {
      if (contact?.type?.id === 'phone') {
        return this.$core.utils.number.formatPhoneNumber(contact.value);
      }

      return contact.value;
    },
  },
});
</script>